import styled from "styled-components";

const RemarkTextarea = styled.textarea`
  width: 50%;
  min-height: 80px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 16px;
`;

function Remark({
  remark,
  setRemark,
}: {
  remark: string;
  setRemark: (value: string) => void;
}) {
  return (
    <>
      <h4>REMARK:</h4>
      <RemarkTextarea
        value={remark}
        onChange={(e) => setRemark(e.target.value)}
      />
    </>
  );
}

export default Remark;
